<template>
  <v-row :justify="justify" no-gutters>
    <div :class="(larger) ? 'text-body-2' : 'text-caption'" class="mr-2">
      <v-icon :color="$getScoreColorHex(0) + 'CC'"
              :iconSize="(iconSize) ? iconSize: '18'"
      >mdi mdi-sprout-outline
      </v-icon>
      {{ $t('swot_types.weakness') }}
    </div>

    <div :class="(larger) ? 'text-body-2' : 'text-caption'" class="mr-2">
      <v-icon :color="$getScoreColorHex(50) + 'CC'"
              :iconSize="(iconSize) ? iconSize: '18'"
      >mdi mdi-watering-can-outline
      </v-icon>
      {{ $t('swot_types.opportunity') }}
    </div>

    <div :class="(larger) ? 'text-body-2' : 'text-caption'" class="mr-2">
      <v-icon :color="$getScoreColorHex(100) + 'CC'"
              :iconSize="(iconSize) ? iconSize: '18'"
      >mdi mdi-flower-tulip-outline
      </v-icon>
      {{ $t('swot_types.strength') }}
    </div>
  </v-row>
</template>
<script>
export default {
  name: 'SWOTLegends',
  props: ['justify', 'iconSize', 'larger']
}
</script>
